import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { AuthGuard } from '../../abacus/guards/auth.guard'
import { PermissionGuard } from '../../abacus/guards/permission.guard'

import { EngagementMechanismListComponent } from './engagement-mechanism-list/engagement-mechanism-list.component'

export const engagementMechanismRoutes: Route[] = [
  {
    path: 'engagement-mechanisms',
    component: EngagementMechanismListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browsePolicyInitiativeTaxonomies'
    }
  },
  {
    path: 'engagement-mechanisms/:id/edit',
    redirectTo: 'engagement-mechanisms/:id',
    pathMatch: 'full'
  },
  {
    path: 'engagement-mechanisms/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'EngagementMechanism',
        nameSingular: 'Engagement Mechanism',
        namePlural: 'Engagement Mechanisms',
        path: 'engagement-mechanisms',
        slug: 'taxonomies/engagement-mechanisms',
        title: 'Engagement Mechanisms'
      }),
      permission: 'readPolicyInitiativeTaxonomies'
    }
  }
]
